import { meta } from '@/config'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.provide('getMetaTags', meta.setupMetaTags)
})